import React from "react";
import { Image, ScrollView, Text, TouchableOpacity, View } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

const WithdrawMethod = () => {
  const navigation = useNavigation();

  return (
    <View>
      <HeaderDefault title={"Sacar"} />

      <ScrollView style={styles.container}>
        <TouchableOpacity
          onPress={() => navigation.navigate("WithdrawGPXAccountSelection")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5" }]}
            source={require("../../../assets/imgs/currentBrl.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Sacar GPX {'->'} BRL (Real Brasileiro)</Text>
            <Text>
              Realize o saque de GPX para BRL
            </Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => navigation.navigate("WithdrawCryptoSelection")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5" }]}
            source={require("../../../assets/imgs/blockchain.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Sacar BTC, ETH ou ADA</Text>
            <Text>Realize o saque de criptoativos para a sua carteira.</Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
            onPress={() => { }}
          />
        </TouchableOpacity>        
        <TouchableOpacity
          onPress={() => navigation.navigate("PaperWallet")}
          style={styles.listItem}
        >
          <Image
            style={[styles.icon, { tintColor: "#1FBFB5", resizeMode: 'contain' }]}
            source={require("../../../assets/imgs/file.png")}
          />
          <View style={styles.itemTextSection}>
            <Text style={styles.textBold}>Sacar para Paper Wallet</Text>
            <Text>Realize o saque de ativos e criptoativos para uma nova Paper Wallet.</Text>
          </View>
          <MaterialIcons
            name="keyboard-arrow-right"
            size={24}
            color="#2C2C2E"
            style={styles.iconGo}
            onPress={() => { }}
          />
        </TouchableOpacity>

      </ScrollView>
    </View>
  );
};

export default WithdrawMethod;
